export default __webpack_public_path__ + "static/media/greyArrow.6861164e.svg";